import React from 'react';
import { Routes, Route, Navigate, useLocation } from "react-router-dom";
import Home from '../Content/Home';
import InvalidPath from '../Content/InvalidPath';
import ScratchAndWin from '../Content/ScratchAndWin';

// Handles:
// https://rate.lokaci.com?abc
// https://rate.lokaci.com/?abc
// https://rate.lokaci.com/??abc
// by redirecting to:
// https://rate.lokaci.com/abc
const QueryKeyRedirect = () => {
    const location = useLocation();

    // Remove one or more leading '?' characters.
    const key = location.search.replace(/^\?+/, "").trim();

    if (!key) {
        return <InvalidPath />;
    }

    return <Navigate to={`/${key}`} replace />;
};

const MainNavigator = () => {
    return (
        <Routes>
            <Route path="/" element={<QueryKeyRedirect />} />
            <Route path=":key" element={<Home />} />
            <Route path="*" element={<InvalidPath />} />
        </Routes>
    );
};

export default MainNavigator;